import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export interface PlanForTerminationPayload {
  plan_id: string;
  coverage_end_date?: string | null;
  claim_last_date?: string | null;
  hsa_transfer_of_assets?: string;
}

interface EmployerTerminationPayload {
  termination_date: string;
  plans_for_termination: PlanForTerminationPayload[];
}

export const useTerminateEmployerQuery = (id: string) => {
  const { mutateAsync, isSuccess, isPending } = useMutation((data: EmployerTerminationPayload) =>
    api.put(API_URL.ORGANIZATIONS_TERMINATION_BY_ORGANIZATION_ID(id), data)
  );

  const {
    mutateAsync: createAsync,
    isPending: createLoading,
    isSuccess: createSuccess,
  } = useMutation((data: EmployerTerminationPayload) =>
    api.post(API_URL.ORGANIZATIONS_TERMINATION_BY_ORGANIZATION_ID(id), data)
  );

  return {
    terminateEmployer: createAsync,
    updateEmployerTermination: mutateAsync,
    isLoading: isPending || createLoading,
    isSuccess: isSuccess || createSuccess,
  };
};
